import { DateTimeRenderer } from "../../datetime/DateTimeFormatter";
import { EntitySidebarTile, EntitySidebarTileProps } from "./EntitySidebarTile/EntitySidebarTile";
import { NotSet } from "../../misc/UIconstants";
import {
  CustomType,
  CustomTypeFilters,
  CustomTypeFiltersTranslator,
  CustomTypeSortingOptionsConsts,
  customTypeConstants,
} from "../../../api/CustomTypes/CustomTypes";
import { CustomTypeEntityTypeOptionToIcon } from "../../../Customization/CustomTypes/CustomTypeRenderUtils";
import { customTypesFiltersToForm } from "../../../Customization/CustomTypes/Table/CustomTypesFilterBar";
import { RenderTabStoreHistoryButton } from "../../tables/Tabs/history/TabStoreHistory";
import { Dispatch, SetStateAction, useCallback } from "react";

export const CustomTypeTile = (props: EntitySidebarTileProps<CustomType, CustomTypeFilters>) => {
  const controlsUnfolded = useCallback(
    ({
      filters,
      setFilters,
    }: {
      filters: CustomTypeFilters;
      setFilters: Dispatch<SetStateAction<CustomTypeFilters>>;
    }) => {
      return (
        <>
          <RenderTabStoreHistoryButton
            entityConstants={customTypeConstants}
            filters={filters}
            filtersToForm={customTypesFiltersToForm}
          />
        </>
      );
    },
    []
  );
  return (
    <EntitySidebarTile<CustomType, CustomTypeFilters>
      rowLabel={(e) => <>{e.name}</>}
      rowDate={(e) => (
        <>{e.enteredOn ? <DateTimeRenderer date={e.enteredOn} includeElapsed={false} includeTime={false} /> : NotSet}</>
      )}
      rowInfo={(e) => (
        <div className="flex row-nowrap align-center gap-5">
          Entity type:
          <CustomTypeEntityTypeOptionToIcon entityType={e.entityType} />
          {e.entityType}
        </div>
      )}
      controlsUnfolded={props.controlsUnfolded ?? controlsUnfolded}
      {...props}
      entityConstants={customTypeConstants}
      orderByOptions={CustomTypeSortingOptionsConsts}
      translatorConsts={CustomTypeFiltersTranslator}
      defaultFilters={{ sortBy: [{ property: "NAME", sortDirection: "ASC" }], ...props.defaultFilters }}
    />
  );
};
